import { QueryKey } from '@/configs/queryKeys';
import { CreatorProductModule } from './CreatorProductModuleApi';
import { Attachment, UUID } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';
import PresetApi from './PresetApi';

export interface Project extends BaseEntity {
	creatorProductModules: CreatorProductModule[];
	price: number;
	image?: Attachment;
}

class ProjectApi extends EntityApi<Project> {
	constructor() {
		super(QueryKey.projects);
		this.clear = this.clear.bind(this);
		this.createFromPreset = this.createFromPreset.bind(this);
		this.exportFile = this.exportFile.bind(this);
	}

	async clear(id: UUID) {
		const response = await httpClient.patch<Project>(
			`${this.queryKey}/${id}/clear`
		);
		return response.data;
	}

	async createFromPreset({
		presetId,
		projectId,
	}: {
		presetId: UUID;
		projectId: UUID;
	}) {
		const preset = await PresetApi.mutationGetOne(presetId);

		const response = await httpClient.patch<Project>(
			`${this.queryKey}/${projectId}/from-preset`,
			{
				preset: {
					id: presetId,
				},
			}
		);

		return { project: response.data, preset };
	}

	async exportFile({ id, type }: { id: UUID; type: 'pdf' | 'xlsx' }) {
		const response = await httpClient.get<Blob>(
			`${this.queryKey}/${id}/export/${type}`,
			{
				responseType: 'blob',
			}
		);

		return response.data;
	}

	async setCreatorProductModulesOrder({
		projectId,
		listOrder,
	}: {
		projectId: UUID;
		listOrder: UUID[];
	}) {
		const response = await httpClient.patch<Project>(
			`${this.queryKey}/${projectId}/order`,
			{
				listOrder,
			}
		);

		return response.data;
	}
}

export default new ProjectApi();
